import { FileText, MoreHorizontal, Trash2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { ProjectInvoice } from '@/types'

interface InvoiceRowActionsProps {
  invoice: ProjectInvoice
  onPreview: () => void
  onDelete: () => void
}

/**
 * SOLY-INV-001 — actions for an invoice row.
 * "Aperçu" stays a direct button; "Supprimer" lives in a discreet kebab menu,
 * rendered ONLY on the organization's last invoice (invoice.canDelete), to avoid a
 * visual collision with the section header's "Note de crédit" button.
 */
export function InvoiceRowActions({ invoice, onPreview, onDelete }: InvoiceRowActionsProps) {
  return (
    <div className="flex items-center justify-end gap-1">
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={onPreview}
        aria-label="Aperçu"
        data-testid="invoice-row-preview-btn"
      >
        <FileText className="h-4 w-4" />
      </Button>

      {invoice.canDelete && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              aria-label="Plus d'actions"
              data-testid="invoice-row-actions-menu-btn"
            >
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              variant="destructive"
              onSelect={onDelete}
              data-testid="invoice-row-delete-btn"
            >
              <Trash2 className="h-4 w-4" />
              Supprimer
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  )
}
